import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";
import { FaLocationDot } from "react-icons/fa6";
import { FaEnvelope, FaPhone, FaTimes } from "react-icons/fa";
const BoardDetails = () => {
  const pageTitle = "Board & Committee Details";
  const [activeTab, setActiveTab] = useState("board");
  const [selectedMember, setSelectedMember] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setSelectedMember(null);
    };
    if (selectedMember) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyDown);
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedMember]);

  const boardData = [
     {
      name: "Mr. Prasoon Chauhan",
      role: "Founder & M.D",
      image: "/img2/DSC_1281.jpg",
      description:
        `Prasoon Chauhan, is the Promoter, Managing Director, and Founder of our Company. He holds a Post Graduate Diploma in Executive Management from the Institute of Management Technology and a Bachelor of Arts degree from the University of Allahabad. He has also successfully completed the Junior Associate of the Indian Institute of Bankers (JAIIB) examination conducted by the Indian Institute of Banking and Finance.

Mr. Chauhan has over eighteen years of diverse experience spanning banking, real estate, and financial consulting. He began his career with Yes Bank Limited, where he served for around 10 years before demitting office in May 2017. Subsequently, he joined ATS Homekraft, the real estate development arm of ATS Group, as Chief Executive Officer, where he served from May 2017 to July 2020.

In September 2020, he founded Black Opal Consultants Limited, a company engaged in providing real estate brokerage services by facilitating the sale of properties in return for brokerage income. Under his leadership, the Company has demonstrated consistent growth and strengthened its position in the real estate brokerage segment.

Mr. Chauhan’s extensive experience in financial services, infrastructure, and real estate sectors, coupled with his entrepreneurial vision and leadership acumen, has been instrumental in shaping the strategic direction and growth plans of our Company.`
       
    },
     {
      name: "Mr. Sheikh Arfeen Ahmed",
      role: "Non-Executive Director",
      image: "/img2/Afreen Ahmad.png",
      description:
        "Sheikh Arfeen Ahmed, is a Non-Executive Director of our Company and has been serving on the Board since February 14, 2025. He holds a Bachelor of Commerce (Hons.) degree from Delhi University and has completed a two-year full-time course in Planning and Entrepreneurship from The Indian Institute of Planning & Management, Delhi. He has over 7 years of experience in real estate, banking, and investment property consultancy, with expertise in sales, business planning, and financial services. He is founder of one of our group entity Grabhome Consulting Private Limited which is into Real Estate Brokerage and Consultancy business and work closely with our company. He has joined our Company in February 2025.",
    },
    {
      name: "Mr. Sandeep Kumar Singh",
      role: "Non-Executive Director",
      image: "/img2/Sandeep singh.png",
      description:
        "Sandeep Kumar Singh, is the Non- Executive Director of our Company. He holds an MBA in Marketing from Chaudhary Charan Singh University, Meerut and B.Sc. from Rohilkhand University, Bareilly. He has over 22 years of experience in business operations, sales, liasoning, supply chain management, and customer relationship management, having previously worked with leading organizations such as Reliance Jio, Idea Cellular, Britannia etc. He joined our Company in October 2024 and plays a key role in overseeing operations, channel coordination, and strategic execution.",
    },
    {
      name: "Ms. Sangeeta Bhatia",
      role: "Independent Director",
      image: "/img2/Sangeeta.jpg",
      description:
        "Sangeeta Bhatia, is an Independent Director of our Company, appointed to the Board on April 30, 2025. She holds Bachelor of Science degree from Delhi University and a Post Graduate Diploma in International Trade from Punjab University. She became a member of The Council of Chartered Financial Analysts with effect from September 15, 1998. She has around 36 years of experience with NTPC Limited, where she superannuated as the Executive Director (Finance). During her tenure, she also served on the Boards of Six NTPC Group companies. She is registered with the Indian Institute of Corporate Affairs as an Independent Director.",
    },
    {
      name: "Mr. Pradeep Pasari",
      role: "Independent Director",
      image: "/img2/Pradeep.jpg",
      description:
        "Pradeep Pasari, is an Independent Director of our Company, appointed to the Board on April 30, 2025. He is a qualified Company Secretary and Chartered Accountant and holds a Bachelor of Commerce degree. He is registered with the Indian Institute of Corporate Affairs as an Independent Director.",
    },
   
  ];

  const auditCommitte = [
    {
      name: "Mr. Pradeep Pasari",
      role: "Chairman",
      nature: "Non-Executive-Independent Director"
   
    },
     {
      name: "Ms. Sangeeta Bhatia",
      role: "Member",
      nature: "Non-Executive-Independent Director"

    },
     {
      name: "Mr. Sheikh Arfeen Ahmed",
      role: "Member",
      nature: "Non-Executive Director"

    },
  ]


  
  const Remuneration_Committee = [
    {
      name: "Ms. Sangeeta Bhatia",
      role: "Chairman",
      nature: "Non-Executive-Independent Director"
   
    },
     {
      name: "Mr. Pradeep Pasari",
      role: "Member",
      nature: "Non-Executive-Independent Director"

    },
     {
      name: "Mr. Sheikh Arfeen Ahmed",
      role: "Member",
      nature: "Non-Executive Director"

    },
  ]


   const stakeholders =  [
    {
      name: "Mr. Pradeep Pasari",
      role: "Chairman",
      nature: "Non-Executive-Independent Director"
   
    },
     {
      name: "Ms. Sangeeta Bhatia",
      role: "Member",
      nature: "Non-Executive-Independent Director"

    },
     {
      name: "Mr. Sandeep Kumar Singh",
      role: "Member",
      nature: "Non-Executive Director"

    },
  ]

  const corporatePolicies = [
    {
      title: "PIT Code of Conduct",
      url: "/assets/pdf/Corporate_Policies/Code_of_Conduct.pdf",
    },
    { title: "Nomination and Remuneration Policy", url: "/assets/pdf/Corporate_Policies/2.Nomination and Remuneration Policy- Final.pdf" },
    {
      title: "Policy on Preservation of Documents",
      url: "/assets/pdf/Corporate_Policies/3. Policy on Preservation of Documents- Final.pdf",
    },
    {
      title: "Policy on Sexual Harassment",
      url: "/assets/pdf/Corporate_Policies/4. Policy on Sexual Harassment- Final.pdf",
    },
    { title: "Policy on Dealing with Related Party Transactions", url: "/assets/pdf/Corporate_Policies/6.Policy on Dealing with Related Party Transactions- Final.pdf" },
    {
      title: "Code of Conduct - Policy",
      url: "/assets/pdf/Corporate_Policies/7.Code of Conduct - Policy- Final.pdf",
    },
     {
      title: "Policy and Procedures for Inquiry in Case of Leak or Suspected Leak of UPSI",
      url: "/assets/pdf/Corporate_Policies/8. Policy and Procedures for Inquiry in Case of Leak or Suspected Leak of UPSI- Final.pdf",
    },
     {
      title: "Code of Fair Disclosure of Unpublished Price Sensitive Information",
      url: "/assets/pdf/Corporate_Policies/9.Code of Fair Disclosure of Unpublished Price Sensitive Information- Final.pdf",
    },
     {
      title: "Risk Assessment and Management Policy",
      url: "/assets/pdf/Corporate_Policies/10. Risk Assessment and Management Policy- Final.pdf",
    },
     {
      title: "Board Diversity Policy",
      url: "/assets/pdf/Corporate_Policies/11.Board Diversity Policy- Final.pdf",
    },
     {
      title: "CSR Policy",
      url: "/assets/pdf/Corporate_Policies/12.CSR Policy- Final.pdf",
    },
     {
      title: "Policy for Declaration and Payment of Dividend",
      url: "/assets/pdf/Corporate_Policies/13. Policy for Declaration and Payment of Dividend- Final.pdf",
    },
     {
      title: "Familiarisation Programme",
      url: "/assets/pdf/Corporate_Policies/14.Familiarisation_Programme- Final.pdf",
    },
     {
      title: "Whistle Blower Policy",
      url: "/assets/pdf/Corporate_Policies/Whistle Blower Policy- Final.pdf",
    },


     {
      title: "Criteria for making payments to the NED",
      url: "/assets/pdf/Corporate_Policies/Criteria for making payments to the NED.pdf",
    },


     {
      title: "Policy_on_Materiality events",
      url: "/assets/pdf/Corporate_Policies/Policy_on_Materiality events.pdf",
    },

     {
      title: "TERMS AND CONDITIONS FOR APPOINTMENT OF INDEPENDENT DIRECTORS",
      url: "/assets/pdf/Corporate_Policies/TERMS AND CONDITIONS FOR APPOINTMENT OF INDEPENDENT DIRECTORS.pdf",
    },

    
  ];

  const getTruncatedContent = (text, limit = 65) => {
    if (!text) return { displayText: "", isTruncated: false };
    const words = text.trim().split(/\s+/);
    if (words.length <= limit) {
      return { displayText: text, isTruncated: false };
    }
    return {
      displayText: words.slice(0, limit).join(" ") + "...",
      isTruncated: true,
    };
  };

  const renderCards = (data) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6 items-stretch">
      {data.map((item, index) => {
        const { displayText, isTruncated } = getTruncatedContent(item.description, 65);
        return (
          <div
            key={index}
            className={`p-6 bg-white border border-gray-200 rounded-tr-[50px] rounded-bl-[50px] shadow hover:shadow-md transition-shadow flex flex-col justify-between h-full ${
              item.description ? "min-h-[380px]" : ""
            }`}
          >
            {/* Profile Image and Info Section */}
            <div className="flex-1 flex flex-col">
              <div className="flex items-start gap-4 mb-4">
                {/* Profile Image */}
                {item.image && (
                  <div className="w-20 h-20 rounded-tr-[20px] rounded-bl-[20px] overflow-hidden flex-shrink-0 bg-gray-100 border border-gray-100">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                )}

                {/* Name and Role */}
                <div className="!flex-1 !min-w-0 !flex !flex-col !justify-start mt-2">
                  <div className="!text-md !font-semibold !text-gray-800 !leading-tight">
                    {item.name}
                  </div>
                  <p className="!text-sm !text-gray-500 !mt-2">{item.role}</p>
                  {item.nature && (
                    <p className="!text-xs !text-gray-500 !-mt-2">{item.nature}</p>
                  )}
                </div>
              </div>

              {/* Description */}
              {item.description && (
                <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">
                  {displayText}
                </p>
              )}
            </div>

            {/* See more action or placeholder */}
            {isTruncated ? (
              <div className="mt-4 pt-2 border-t border-gray-100 flex justify-end">
                <button
                  type="button"
                  onClick={() => setSelectedMember(item)}
                  style={{ background: "transparent", border: "none", padding: 0 }}
                  className="!bg-transparent !border-0 !p-0 !shadow-none !text-[#F26624] font-semibold text-xs sm:text-sm hover:underline inline-flex items-center gap-1 focus:outline-none cursor-pointer"
                >
                  See more →
                </button>
              </div>
            ) : item.description ? (
              <div className="mt-4 pt-2 border-t border-transparent flex justify-end invisible select-none pointer-events-none">
                <span className="text-xs sm:text-sm font-semibold">&nbsp;</span>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );

  const renderPolicies = () => (
    <div className="mt-12 text-start">
    <h2 className="text-2xl font-bold mb-6 !text-[#F26624]">
        Corporate Policies
      </h2>
      {corporatePolicies.map((policy, index) => (
        <div
          key={index}
          className="flex justify-between !items-center w-full py-3 bg-white !shadow-md hover:shadow-lg hover:scale-105 transition-transform duration-300 mb-2 px-4 border-1 rounded-xl"
          onClick={() => window.open(policy.url, "_blank")}
          style={{ cursor: "pointer" }}
        >
          <span className="!text-xs !sm:text-[10px] !font-medium !items-center">
            {policy.title}
          </span>
        <span className="!text-xs !sm:text-[10px] !whitespace-nowrap"> View →</span>
        </div>
      ))}
    </div>
  );

  const investorContact = () => (
    <div className="mt-12 text-start">
      {/* <h2 className="text-2xl font-bold mb-6 !text-[#F26624]">
        Investor Contacts
      </h2> */}
      <div className="!text-lg mb-1 text-gray-800">Registered Office</div>
      <div className="border-1 w-24 border-[#F26624]"></div>
      <p className="!text-xs mt-4 flex gap-2 items-center !font-medium">
        <FaLocationDot /> Shop No. 8, Ground Floor, C.S.C. AGCR Enclave, East Delhi, Delhi, Delhi, India, 110092
      </p>
      {/* <div className="flex gap-3 items-center !rounded-md">
        <img src="/assets/img/Report_1.png" alt="map" className="w-10 h-10 " />
        <a href="" className="text-xs !text-[blue] !underline">
          View on map
        </a>
      </div> */}
      <div className="mt-5">
        <div className="!text-lg mb-1 text-gray-800">
          Company Secretary & Compliance Officer
        </div>
        <div className="border-1 w-44 border-[#F26624]"></div>
        <p className="!text-md mt-4 !font-medium">Mrs. Anju</p>
        <div className="flex flex-col">
          <div className="flex gap-24">
            <p className="!text-xs  flex gap-2 items-center">
              <FaPhone /> Contact No.
            </p>
            <p className="!text-xs flex gap-2 items-center !font-bold">
              {" "}
              +91 0120-5109230
            </p>
          </div>

          <div className="flex gap-20 sm:gap-28">
            <p className="!text-xs  flex gap-2  items-center">
              <FaEnvelope /> Email id:
            </p>
            <p className="!text-xs flex gap-2 items-center !font-bold">
               Investors@blackopalgroup.in
            </p>
          </div>
        </div>
      </div>
      <div className="mt-5">
        <div className="!text-lg mb-1 text-gray-800 capitalize">Registrar and transfer agent</div>
        <div className="border-1 w-40 border-[#F26624]"></div>
        <p className="!text-md mt-4 !font-medium">Skyline Financial Services Private Limited,</p>
        <div className="flex flex-col">
          <div className="flex gap-32">
            <p className="!text-xs  flex gap-2 items-center">
              <FaPhone /> Tel No.
            </p>
            <p className="!text-xs flex gap-2 items-center !font-bold">
              {" "}
             011-40450193-97
            </p>
          </div>

          <div className="flex gap-16">
            <p className="!text-xs  flex gap-2 items-center">
              <FaPhone /> Tel No (Toll free).
            </p>
            <p className="!text-xs flex gap-2 items-center !font-bold">
              {" "}
               011-26812682-83
            </p>
          </div>
          <p className="!text-xs flex gap-2 items-center !font-medium">
            <FaLocationDot /> D-153A , 1st Floor, Okhla Industrial Area, Phase -I, New Delhi - 110 020
          </p>
          {/* <div className="flex gap-3 items-center !rounded-md">
            <img
              src="/assets/img/Report_1.png"
              alt="map"
              className="w-10 h-10 "
            />
            <a href="" className="text-xs !text-[blue] !underline">
              View on map
            </a>
          </div> */}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <div className="main-content">
        <Header />

        {/* Banner Section */}
        <div
          className="relative w-full h-64 md:h-80 lg:h-96"
          style={{
            backgroundImage: `url(/assets/img/Board_banner.png)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
          }}
        ></div>

        {/* Page Content */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4 text-start">
            <h2 className="text-2xl font-bold mb-6 !text-[#F26624]">
              Board & Committee Details
            </h2>
            {/* Tabs */}
            <div className="flex overflow-x-auto whitespace-nowrap gap-2 pb-2 sm:gap-6 sm:justify-center scrollbar-hide">
              {[
                { id: "board", label: "Board of Directors & KMP" },
                { id: "audit", label: "Audit Committee" },
                { id: "nomination", label: "Nomination & Remuneration Committee" },
                { id: "stakeholders", label: "Stakeholders Relationship Committee" },
              ].map((tab) => (
                <button
                  key={tab.id}
                  className={`relative text-xs sm:text-sm font-medium px-3 py-2 transition-colors ${
                    activeTab === tab.id
                      ? "!text-[#F26624] !bg-transparent"
                      : "!text-gray-500 hover:text-gray-700 !bg-transparent"
                  }`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                  {activeTab === tab.id && (
                    <span className="absolute left-0 bottom-0 w-full h-0.5 bg-[#F26624] rounded"></span>
                  )}
                </button>
              ))}
            </div>
            {/* Cards */}
            {activeTab === "board" && renderCards(boardData)}
            {activeTab === "audit" && renderCards(auditCommitte)}
            {activeTab === "nomination" && renderCards(Remuneration_Committee)}
            {activeTab === "stakeholders" && renderCards(stakeholders)}
            {/* Corporate Policies */}
            {renderPolicies()}
            {/* Investor Contact */}
            {investorContact()}
          </div>
        </section>

        {/* Modal / Popup for Full Profile Content */}
        {selectedMember && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
            onClick={(e) => {
              if (e.target === e.currentTarget) setSelectedMember(null);
            }}
          >
            <div className="relative bg-white rounded-tr-[40px] rounded-bl-[40px] rounded-tl-2xl rounded-br-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col overflow-hidden">
              {/* Header */}
              <div className="p-6 pb-4 border-b border-gray-100 flex items-start justify-between gap-4 bg-[#F26624]/5">
                <div className="flex items-center gap-4">
                  {selectedMember.image && (
                    <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-tr-[16px] rounded-bl-[16px] overflow-hidden flex-shrink-0 bg-white border border-gray-200">
                      <img
                        src={selectedMember.image}
                        alt={selectedMember.name}
                        className="w-full h-full object-contain"
                      />
                    </div>
                  )}
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 leading-tight">
                      {selectedMember.name}
                    </h3>
                    <p className="text-sm sm:text-base font-semibold text-[#F26624] mt-1">
                      {selectedMember.role}
                    </p>
                    {selectedMember.nature && (
                      <p className="text-xs text-gray-500 mt-0.5">
                        {selectedMember.nature}
                      </p>
                    )}
                  </div>
                </div>

                {/* Close Button */}
                <button
                  type="button"
                  onClick={() => setSelectedMember(null)}
                  className="text-gray-400 hover:text-gray-600 p-2 rounded-full hover:bg-gray-100 transition-colors focus:outline-none cursor-pointer"
                  aria-label="Close modal"
                >
                  <FaTimes className="w-5 h-5" />
                </button>
              </div>

              {/* Scrollable Description Body */}
              <div className="p-6 overflow-y-auto max-h-[60vh]">
                <div className="text-gray-700 text-sm sm:text-base leading-relaxed whitespace-pre-line">
                  {selectedMember.description}
                </div>
              </div>

              {/* Footer */}
              <div className="p-4 px-6 border-t border-gray-100 flex justify-end bg-gray-50">
                <button
                  type="button"
                  onClick={() => setSelectedMember(null)}
                  className="px-5 py-2 bg-[#F26624] text-white rounded-lg hover:bg-[#d8551a] transition-colors font-medium text-sm focus:outline-none cursor-pointer shadow-sm"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        <Footer />
      </div>
    </>
  );
};

export default BoardDetails;
